import NextI18Next from '../../i18n';

/**
 *
 * @param language  I18n.language
 *
 * extend function if you need long string for specific localizations
 *
 *
 */

type LanguageLongString = 'fr-FR' | 'pt-PT' | 'es-ES';

export const getLanguageLongString = (language: string): LanguageLongString => {
    switch (language) {
        case 'fr':
            return 'fr-FR';
        case 'pt':
            return 'pt-PT';

        case 'es':
            return 'es-ES';

        default:
            return 'fr-FR';
    }
};

export const getLanguage = (): string => {
    return NextI18Next.i18n.language || NextI18Next.i18n.options.fallbackLng.toString();
};
